module.exports = __webpack_public_path__ + "assets/img/con2-bg.23e2a890.jpg";